import { useRouter } from 'next/router';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { Banner, Button } from '~components';

const messages = defineMessages({
  back: 'Back to overview',
  shopOffers: 'Shop offers',
});

export const Header = ({ content, removeBackButton }) => {
  const intl = useIntl();
  const { query } = useRouter();
  const hasImage = !!content?.image?.filename;

  const backButton = !content?.isPromotion && {
    to: `/shop${query?.slug?.length > 1 ? `/${query?.slug?.[0]}` : ''}`,
    label: intl.formatMessage(messages.back),
  };

  return (
    <Banner {...content} backButton={removeBackButton ? null : backButton}>
      {!!content?.isPromotion && (
        <Button variant="secondary" mt={hasImage ? [5, 10] : 5}>
          <FormattedMessage {...messages.shopOffers} />
        </Button>
      )}
    </Banner>
  );
};
